import { ɵɵdefineInjectable, Injectable, EventEmitter, ElementRef, Input, Output, HostListener, Directive, NgModule } from '@angular/core';
import { saveAs } from 'file-saver';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let FileSaverService = class FileSaverService {
    get isFileSaverSupported() {
        try {
            return !!new Blob();
        }
        catch (e) {
            return false;
        }
    }
    genType(fileName) {
        if (!fileName || fileName.lastIndexOf('.') === -1) {
            return 'text/plain';
        }
        const type = fileName.substr(fileName.lastIndexOf('.') + 1);
        switch (type) {
            case 'txt':
                return 'text/plain';
            case 'xml':
            case 'html':
                return `text/${type}`;
            case 'json':
                return 'octet/stream';
            default:
                return `application/${type}`;
        }
    }
    save(blob, fileName, filtType, option) {
        if (!blob) {
            throw new Error('Data argument should be a blob instance');
        }
        const file = new Blob([blob], { type: filtType || blob.type || this.genType(fileName) });
        saveAs(file, decodeURI(fileName || 'download'), option);
    }
    saveText(txt, fileName, option) {
        const blob = new Blob([txt]);
        this.save(blob, fileName, null, option);
    }
};
FileSaverService.ɵfac = function FileSaverService_Factory(t) { return new (t || FileSaverService)(); };
FileSaverService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FileSaverService, factory: function (t) { return FileSaverService.ɵfac(t); }, providedIn: 'root' });
FileSaverService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FileSaverService_Factory() { return new FileSaverService(); }, token: FileSaverService, providedIn: "root" });

var __decorate$1 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let FileSaverDirective = class FileSaverDirective {
    constructor(el, fss, httpClient) {
        this.el = el;
        this.fss = fss;
        this.httpClient = httpClient;
        this.method = 'GET';
        this.success = new EventEmitter();
        this.error = new EventEmitter();
        if (!fss.isFileSaverSupported) {
            el.nativeElement.classList.add(`filesaver__not-support`);
        }
    }
    getName(res) {
        return decodeURI(this.fileName || res.headers.get('filename') || res.headers.get('x-filename'));
    }
    _click() {
        if (!this.fss.isFileSaverSupported) {
            return;
        }
        let req = this.http;
        if (!req) {
            const params = new HttpParams();
            const query = this.query || {};
            // tslint:disable-next-line:forin
            for (const item in query) {
                params.set(item, query[item]);
            }
            req = this.httpClient.request(this.method, this.url, {
                observe: 'response',
                responseType: 'blob',
                headers: this.header,
                params,
            });
        }
        this.setDisabled(true);
        req.subscribe(res => {
            if (res.status !== 200 || res.body.size <= 0) {
                this.error.emit(res);
                return;
            }
            this.fss.save(res.body, this.getName(res), null, this.fsOptions);
            this.success.emit(res);
        }, err => this.error.emit(err), () => this.setDisabled(false));
    }
    setDisabled(status) {
        const el = this.el.nativeElement;
        el.disabled = status;
        el.classList[status ? 'add' : 'remove'](`filesaver__disabled`);
    }
};
FileSaverDirective.ɵfac = function FileSaverDirective_Factory(t) { return new (t || FileSaverDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(FileSaverService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.HttpClient)); };
FileSaverDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FileSaverDirective, selectors: [["", "fileSaver", ""]], hostBindings: function FileSaverDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function FileSaverDirective_click_HostBindingHandler() { return ctx._click(); });
    } }, inputs: { method: "method", http: "http", query: "query", header: "header", url: "url", fileName: "fileName", fsOptions: "fsOptions" }, outputs: { success: "success", error: "error" }, exportAs: ["fileSaver"] });
FileSaverDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: FileSaverService },
    { type: HttpClient }
];
__decorate$1([
    Input(),
    __metadata("design:type", Object)
], FileSaverDirective.prototype, "method", void 0);
__decorate$1([
    Input(),
    __metadata("design:type", Observable)
], FileSaverDirective.prototype, "http", void 0);
__decorate$1([
    Input(),
    __metadata("design:type", Object)
], FileSaverDirective.prototype, "query", void 0);
__decorate$1([
    Input(),
    __metadata("design:type", Object)
], FileSaverDirective.prototype, "header", void 0);
__decorate$1([
    Input(),
    __metadata("design:type", String)
], FileSaverDirective.prototype, "url", void 0);
__decorate$1([
    Input(),
    __metadata("design:type", String)
], FileSaverDirective.prototype, "fileName", void 0);
__decorate$1([
    Input(),
    __metadata("design:type", Object)
], FileSaverDirective.prototype, "fsOptions", void 0);
__decorate$1([
    Output(),
    __metadata("design:type", Object)
], FileSaverDirective.prototype, "success", void 0);
__decorate$1([
    Output(),
    __metadata("design:type", Object)
], FileSaverDirective.prototype, "error", void 0);
__decorate$1([
    HostListener('click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FileSaverDirective.prototype, "_click", null);
FileSaverDirective = __decorate$1([ __metadata("design:paramtypes", [ElementRef, FileSaverService, HttpClient])
], FileSaverDirective);

var __decorate$2 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let FileSaverModule = class FileSaverModule {
};
FileSaverModule.ɵfac = function FileSaverModule_Factory(t) { return new (t || FileSaverModule)(); };
FileSaverModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FileSaverModule });
FileSaverModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileSaverService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileSaverDirective, [{
        type: Directive,
        args: [{
                selector: '[fileSaver]',
                exportAs: 'fileSaver'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: FileSaverService }, { type: ɵngcc1.HttpClient }]; }, { method: [{
            type: Input
        }], success: [{
            type: Output
        }], error: [{
            type: Output
        }], _click: [{
            type: HostListener,
            args: ['click']
        }], http: [{
            type: Input
        }], query: [{
            type: Input
        }], header: [{
            type: Input
        }], url: [{
            type: Input
        }], fileName: [{
            type: Input
        }], fsOptions: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileSaverModule, [{
        type: NgModule,
        args: [{
                declarations: [FileSaverDirective],
                exports: [FileSaverDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FileSaverModule, { declarations: [FileSaverDirective], exports: [FileSaverDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { FileSaverDirective, FileSaverModule, FileSaverService };

//# sourceMappingURL=ngx-filesaver.js.map